var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 p-1",style:(_vm.cellStyle),attrs:{"id":"principal"},domProps:{"innerHTML":_vm._s(_vm.value)}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c70940","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/pci/components/FilterCollorCellRenderer.vue
// module id = null
// module chunks = 